let initialSearchContent = document.querySelector(
  ".initial-search-main-content"
).innerHTML;
let initialRightSearchContent = document.querySelector(
  ".initial-search-main-content .search-right-content"
).innerHTML;

let initialSearchMobileProducts = document.querySelector(
  ".suggestion-products-container"
).innerHTML;

// We'll query this element when needed instead of at initialization
let labelSearchElement = document.querySelector("label.new-search-placeholder");
let resetButtonSearch = document.querySelector(".reset__button");

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      // this.closeResults(true);
      console.log("RESET");
      if (labelSearchElement) {
        labelSearchElement.style.display = "block";
      }
      document.querySelector(".initial-search-content").innerHTML =
        initialSearchContent;
      reinitializeCarousels();
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    console.log("loading");
    let predictiveSearchContainer = document.querySelector(
      ".predictive-search-overlay"
    );

    if (predictiveSearchContainer) {
      predictiveSearchContainer.classList.add("overlay");

      // To start loading
      const line = document.querySelector(".line-loader");
      line.style.display = "block";
    }

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        console.log("Search results loaded.");
        if (predictiveSearchContainer) {
          predictiveSearchContainer.classList.remove("overlay");
        }

        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
        console.log("carousel initiated");
        reinitializeCarousels();
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    if (resetButtonSearch) {
      resetButtonSearch.style.display = "block";
    }
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
    let collectionNameElement = document.querySelector(
      ".predictive-search p.title-search-suggestion"
    );

    let collectionNameSearch = null;

    // Check if collectionNameElement exists and has the collectionName attribute
    if (
      collectionNameElement &&
      collectionNameElement.hasAttribute("data-collection-name")
    ) {
      // Get the attribute value
      const attributeValue = collectionNameElement.getAttribute(
        "data-collection-name"
      );

      // Only process if the attribute value is not null or empty
      if (attributeValue) {
        try {
          collectionNameSearch = attributeValue
            .toLowerCase()
            .replace(/\s+/g, "-");
          console.log("Collection name processed:", collectionNameSearch);
        } catch (error) {
          console.error("Error processing collection name:", error);
          // Keep collectionNameSearch as null if there's an error
        }
      } else {
        console.log("Collection name attribute is empty or null");
      }
    }

    console.log(collectionNameSearch);
    reinitializeCarousels();
    if (collectionNameSearch && collectionNameElement) {
      let priceLinks = document.querySelectorAll(
        ".quick-links-search.by-price a"
      );

      priceLinks.forEach((link) => {
        let href = link.getAttribute("href");

        let updatedHref = href.replace(
          "/collections/all",
          `/collections/${collectionNameSearch}`
        );
        link.setAttribute("href", updatedHref);
      });
    }

    // if (
    //   this.predictiveSearchResults.querySelector("#product-grid-search")
    //     .innerHTML.length == 0
    // ) {
    //   console.log("empty");
    //   if (initialRightSearchContent) {
    //     document.querySelector(
    //       ".initial-search-content .search-right-content"
    //     ).innerHTML = initialRightSearchContent;
    //     reinitializeCarousels();
    //   }
    //   document.querySelector(".suggestion-products-container").innerHTML =
    //     initialSearchMobileProducts;
    //   // document.querySelector(
    //   //   "p.search-sub-heading.for-desktop-view"
    //   // ).style.display = "none";
    //   // Query the element when needed to ensure it exists in the DOM
    //   const showNoCategories = document.querySelector(
    //     ".search-sub-heading.categories"
    //   );
    //   const showNoProducts = document.querySelector(
    //     ".search-sub-heading.for-mobile-view"
    //   );
    //   if (showNoCategories) {
    //     showNoCategories.textContent = "NO CATEGORIES FOUND";
    //     showNoProducts.textContent = " NO PRODUCTS FOUND";
    //     console.log("No categories message displayed");
    //   } else {
    //     console.log("Categories element not found in DOM");
    //     // Try again after a short delay to allow DOM to update
    //     setTimeout(() => {
    //       const retryNoCategories = document.querySelector(
    //         ".search-sub-heading.categories"
    //       );
    //       if (retryNoCategories) {
    //         retryNoCategories.textContent = "NO CATEGORIES FOUND";
    //         showNoProducts.textContent = " NO PRODUCTS FOUND";
    //         console.log("No categories message displayed after retry");
    //       }
    //     }, 100);
    //   }
    // }
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    console.log("closed");
    if (resetButtonSearch) {
      resetButtonSearch.style.display = "none";
    }
    if (labelSearchElement) {
      labelSearchElement.style.display = "block";
    }
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
      if (labelSearchElement) {
        labelSearchElement.style.display = "block";
      }
      document.querySelector(".initial-search-content").innerHTML =
        initialSearchContent;
      reinitializeCarousels();
    } else {
      if (labelSearchElement) {
        labelSearchElement.style.display = "none";
      }
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
    // labelSearchElement.style.display = "none";
    // this.input.value = "";
    this.removeAttribute("results");
    document.querySelector(".initial-search-content").innerHTML =
      initialSearchContent;
    reinitializeCarousels();
  }
}

customElements.define("predictive-search", PredictiveSearch);
